export enum InsuranceType {
  Auto = 'AUTO',
  Homeowners = 'HOMEOWNERS',
  Renters = 'RENTERS',
}

type CanopyConnectEventNames =
  | 'authenticationSuccess'
  | 'destroy'
  | 'exit'
  | 'selectCustomInsuranceProvider';

export type CanopyConnectHandler = {
  close: () => void;
  destroy: () => void;
  mount: (selectorOrElement) => void;
  on: (
    eventName: CanopyConnectEventNames,
    listener: (err, data) => void,
  ) => void;
  open: () => void;
};

export type CanopyConnectSDK = {
  create({
    publicAlias,
    modal,
    mount,
    pullMetaData,
  }: {
    publicAlias: string;
    modal?: boolean;
    mount?: string | HTMLElement;
    pullMetaData?: object;
    reconnectToken?: string;
  }): CanopyConnectHandler;
};
